import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedAgenticSnapshotReviewStep =
  () => import(/* webpackChunkName: "agentic-snapshot-review-step.async" */ './agentic-snapshot-review-step')
    .then(({ AgenticSnapshotReviewStepWithI18n }) => AgenticSnapshotReviewStepWithI18n);

const DelayedAgenticSnapshotReviewRepository =
  () => import(/* webpackChunkName: "agentic-snapshot-review-step.async" */ './agentic-snapshot-review-lazy-repository')
    .then(({ AgenticSnapshotReviewLazyRepositoryWithI18n }) => AgenticSnapshotReviewLazyRepositoryWithI18n);

export const AgenticSnapshotReviewStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.AGENTIC_SNAPSHOT_REVIEW,
  view: DelayedAgenticSnapshotReviewStep,
  repository: DelayedAgenticSnapshotReviewRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
};
